var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMultiColorCompass = function SvgMultiColorCompass(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12C20 16.418 16.418 20 12 20C7.582 20 4 16.418 4 12C4 7.582 7.582 4 12 4C16.418 4 20 7.582 20 12Z",
    fill: "#130E3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 10.8016L13.2008 13.2016L15.9656 8.36318C16.0864 8.15158 15.8508 7.91598 15.6392 8.03678L10.8008 10.8016Z",
    fill: "#F71278"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1996 13.1969L10.7996 10.7969L8.03482 15.6353C7.91402 15.8469 8.14962 16.0825 8.36122 15.9617L13.1996 13.1969Z",
    fill: "#46C3F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6004 12.0023C12.6004 12.3339 12.332 12.6023 12.0004 12.6023C11.6688 12.6023 11.4004 12.3339 11.4004 12.0023C11.4004 11.6707 11.6692 11.4023 12.0004 11.4023C12.332 11.4023 12.6004 11.6707 12.6004 12.0023Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMultiColorCompass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/multi-color-compass.33ccc779ae78a21e108dd14bf273eaf7.svg";